import { Box, Button, CircularProgress, Modal, Typography } from '@material-ui/core';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

function PopupModal({
  id,
  openModal,
  handleModalClose,
  heading,
  description,
  icon,
  primaryBtnText,
  secondaryBtnText,
  primaryBtnFunc,
  secondaryBtnFunc,
  primaryBtnColor,
  children,
  width,
  height,
  fullWidth,
  Customheight,
  Customoverflow = 'hidden',
  loading = false,
}) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    outline: 0,
    transform: 'translate(-50%, -50%)',
    width: width ?? 369,
    maxHeight: height ?? 600,
    height: Customheight ?? 'auto',
    bgcolor: 'background.paper',
    padding: !fullWidth ? '20px 26px' : '',
    boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
    borderRadius: '12px',
    overflow: Customoverflow ?? 'auto',
  };
  if (fullWidth) {
    return (
      <Modal
        id={id}
        // BackdropProps={{ style: { height: '120%' } }}
        BackdropProps={{
          classes: {
            root: { height: '120%', zIndex: -1 },
          },
        }}
        disableEnforceFocus
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="popup-modal"
        aria-describedby="sg-popup-modal"
      >
        <Box sx={style}>
          <div>{children}</div>
        </Box>
      </Modal>
    );
  }
  if (children) {
    return (
      <Modal
        id={id}
        disableEnforceFocus
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '0',
              borderBottom: '1px solid rgb(212 212 212 / 65%)',
              paddingBottom: '18px',
              marginBottom: '20px',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginTop: '0', fontWeight: '500', fontSize: '16px', paddingBottom: '0', marginBottom: '0' }}
              >
                {heading}
              </Typography>
              <div className="sectionPara">{description}</div>
            </div>
            <CloseIcon
              className="popupCloseicon"
              onClick={handleModalClose}
              style={{ top: '22px', right: '30px', cursor: 'pointer' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '0',
              // paddingBottom: '10px',
              // marginBottom: '18px',
              alignContent: 'flex-start',
              flexDirection: 'column',
            }}
          >
            {children}
          </div>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal
      id={id}
      disableEnforceFocus
      open={openModal}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <CloseIcon className="popupCloseicon" onClick={handleModalClose} style={{ cursor: 'pointer' }} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '0',
            paddingBottom: '10px',
            marginBottom: '18px',
            alignContent: 'flex-start',
            flexDirection: 'column',
          }}
        >
          <img src={icon} style={{ width: '48px', height: '48px' }} />
          <Typography
            variant="h6"
            style={{ fontWeight: '500', fontSize: '16px', paddingBottom: '0', margin: '14px 0 4px 0' }}
          >
            {heading}
          </Typography>
          <div className="sectionPara">{description}</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            onClick={secondaryBtnFunc}
            className="aisleSecondarycanelButton"
            style={{ width: '100%', marginRight: '10px' }}
          >
            {secondaryBtnText}
          </Button>
          <Button
            onClick={primaryBtnFunc}
            disabled={loading}
            className="popupModalPrimaryBtn"
            style={{ width: '100%', marginleftt: '10px', background: primaryBtnColor || '#d95661' }}
          >
            {loading ? (
              <>
                Updating <CircularProgress size={20} style={{ color: '#fff', marginLeft: '8px' }} />
              </>
            ) : (
              primaryBtnText
            )}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default PopupModal;
